/*
 * drool-default-size.js
 * On a fresh product landing (no ?variant= in the URL), preselect the size whose
 * physical area is closest to TARGET_AREA_IN2 ("Large"), in the Unframed frame.
 * Direct variant links (?variant=...) are respected and left untouched.
 * Applies to the B-side (cards) picker only; the dropdown arm keeps its default.
 */
(function(){
  'use strict';

  // ---- preselect on/off ----
  // false = fall back to Shopify's first-available-variant default.
  //         The script still runs to dedupe the duplicate #mrk-main-variant-data
  //         (required for ATC to read the visible arm) and to run the cart-id
  //         self-heal watchdog — both of which are unrelated to the preselect.
  var ENABLE_PRESELECT = false;
  // --------------------------

  // ---- tune "Large" here (only used when ENABLE_PRESELECT is true) ----
  var TARGET_AREA_IN2 = 386;        // ~A2 (16.5 x 23.4"). Raise/lower to shift what "Large" means.
  var TOKENS = [];                  // optional override, e.g. ['a2','50x70','20x28']; matched against the size value. Empty = use area.
  var UNFRAMED_MATCH = 'unframed';  // text identifying the Unframed frame option
  // ---------------------------

  var IN_PER_CM = 2.54;

  function areaOf(val){
    if(!val) return null; val=String(val);
    var cm = val.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)\s*cm/i);
    if(cm) return (parseFloat(cm[1])/IN_PER_CM)*(parseFloat(cm[2])/IN_PER_CM);
    var inch = val.match(/(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)/);
    if(inch) return parseFloat(inch[1])*parseFloat(inch[2]);
    return null;
  }
  function tokenRank(val){
    if(!TOKENS.length) return -1;
    var v=String(val).toLowerCase();
    for(var i=0;i<TOKENS.length;i++){ if(v.indexOf(String(TOKENS[i]).toLowerCase())!==-1) return i; }
    return -1;
  }
  function avail(r){ return r.getAttribute('data-option-available')!=='false' && !r.disabled; }

  function applyTo(vp){
    var radios = Array.prototype.slice.call(vp.querySelectorAll('input[type=radio]'));
    if(!radios.length) return;
    var groups={};
    radios.forEach(function(r){ (groups[r.name]=groups[r.name]||[]).push(r); });

    var sizeGroup=null, frameRadio=null;
    Object.keys(groups).forEach(function(name){
      var g=groups[name], areaCount=0, unframed=null;
      g.forEach(function(r){
        var v=r.value||r.getAttribute('data-value')||'';
        if(areaOf(v)!=null) areaCount++;
        if(v.toLowerCase().indexOf(UNFRAMED_MATCH)!==-1) unframed=r;
      });
      if(!sizeGroup && areaCount>=Math.max(2,g.length-1)) sizeGroup=g;
      if(unframed) frameRadio=unframed;
    });
    if(!sizeGroup) return;

    var best=null, bestScore=Infinity;
    sizeGroup.forEach(function(r){
      var v=r.value||r.getAttribute('data-value');
      var score, tr=tokenRank(v);
      if(TOKENS.length){ if(tr<0) return; score=tr; }
      else { var a=areaOf(v); if(a==null) return; score=Math.abs(a-TARGET_AREA_IN2); }
      if(!avail(r)) score+=1e6;
      if(score<bestScore){ bestScore=score; best=r; }
    });
    if(!best) return;

    // Only change the SIZE. Leave the frame option as loaded.
    if(!best.checked){
      best.checked=true;
      // After the resulting variant change, the theme's frame logic switches the
      // gallery to the actually-selected (Unframed) frame, dropping the default
      // framed preview. Re-assert that preview once, mirroring mrk.js bootstrap.
      document.addEventListener('mrkVariantChanged', function reassertFrame(){
        document.removeEventListener('mrkVariantChanged', reassertFrame);
        if(!window.show_default_black_variant) return;
        requestAnimationFrame(function(){
          try{
            var wrap='media-gallery .mrk-featured-product-frame-wrapper ';
            var black=document.querySelector(wrap+'.mrk-frame-image-item[color="black"]')
                   || document.querySelector('media-gallery .mrk-frame-image-item[color="black"]');
            if(!black) return;
            Array.prototype.forEach.call(document.querySelectorAll('media-gallery .mrk-frame-image-item.mrk-active-gallery-frame'),
              function(el){ el.classList.remove('mrk-active-gallery-frame'); el.style.display='none'; });
            black.classList.add('mrk-active-gallery-frame'); black.style.display='';
          }catch(e){}
        });
      });
      best.dispatchEvent(new Event('change',{bubbles:true}));
      // NOTE: do NOT dispatch a change on the stock picker. Its <variant-picker>
      // morph grabs the FIRST variant-picker in the fetched section (the cards
      // one), so programmatically changing it makes the stock arm re-render as a
      // duplicate of the cards. In raw two-picker previews the dropdown may show
      // the old size — cosmetic only; the shared price/cart follows the cards.

    }
  }

  // Self-heal: on products without the frame-product picker (e.g. small-format
  // ladders with "Framed black" option2), the chain that refreshes the cart form
  // doesn't always fire after a size/frame morph, leaving items[0][id] empty —
  // add-to-cart then 422s. Cheap watchdog: if the id is empty, re-run the theme's
  // own updateVariants() (idempotent — reads #mrk-main-variant-data).
  setInterval(function(){
    try{
      var inp=document.querySelector('.mrk-product-form-wrapper [name="items[0][id]"]');
      if(inp && !inp.value && typeof window.updateVariants==='function') window.updateVariants();
    }catch(e){}
  }, 700);

  function isHidden(el){
    // True only if the element or an ancestor is actually hidden (display:none / visibility:hidden).
    // Avoids offsetParent, which is null for position:fixed / display:contents (common on mobile).
    var n=el;
    while(n && n.nodeType===1){
      var cs=window.getComputedStyle(n);
      if(cs.display==='none' || cs.visibility==='hidden') return true;
      n=n.parentElement;
    }
    return false;
  }
  function visible(sel){
    return Array.prototype.filter.call(document.querySelectorAll(sel), function(vp){ return !isHidden(vp); });
  }

  // Both A/B arms render a <script id="mrk-main-variant-data">, so the id is
  // DUPLICATED. The bespoke mrk.js reads the FIRST one in the DOM. When the A/B app
  // hides one arm and the shopper uses the OTHER arm, mrk.js was reading the hidden
  // (stale) arm's data — so frame/size changes in the visible arm never updated the
  // cart variant or price (empty items[0][id] / £0, esp. on the control arm).
  // Fix: keep the id ONLY on the visible arm's variant-data; rename the hidden
  // arm's so it can't be picked up. Re-runs on load, poll, and every variant change.
  function ensureSingleVariantData(){
    var nodes = document.querySelectorAll('[id="mrk-main-variant-data"], [id="mrk-main-variant-data-inactive"]');
    if(nodes.length < 2) return; // single picker page (e.g. gift card) — nothing to do
    Array.prototype.forEach.call(nodes, function(el){
      var arm = el.closest && el.closest('.drool-picker-cards, .drool-picker-stock');
      if(!arm) return; // outside the A/B arms — leave the canonical one alone
      el.id = isHidden(arm) ? 'mrk-main-variant-data-inactive' : 'mrk-main-variant-data';
    });
  }
  document.addEventListener('mrkVariantChanged', ensureSingleVariantData);

  function run(){
    ensureSingleVariantData();
    if(!ENABLE_PRESELECT) return;
    try { if (new URLSearchParams(location.search).has('variant')) return; } catch(e){}
    if(window.__droolDefaultSizeDone) return;
    var cards = visible('.drool-picker-cards variant-picker');
    // Fire whenever the CARDS picker is visible. In the control arm Visually hides
    // the cards entirely, so this can never pollute the control. (Previously we
    // also required the stock picker to be hidden, which made the default depend
    // on Visually's hide timing/scoping — unreliable on first views.)
    if(!cards.length) return;   // cards hidden (control arm) → never act
    window.__droolDefaultSizeDone=true;
    applyTo(cards[0]);
  }

  // Run at DOM ready and again at load — then keep POLLING for ~8s. Visually's
  // hide-the-stock-picker CSS often lands AFTER load on a first (uncached) view,
  // which is why the default only used to kick in from the 2nd pageview. Polling
  // catches the B arm as soon as the hide applies; in the control arm (cards
  // hidden) or a raw two-picker preview it simply never fires.
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run);
  else run();
  window.addEventListener('load', run);
  var polls=0;
  var iv=setInterval(function(){
    polls++;
    if(window.__droolDefaultSizeDone || polls>40){ clearInterval(iv); return; }
    run();
  }, 200);
})();
